import { render, staticRenderFns } from "./arrow-btn.vue?vue&type=template&id=d88a4926&scoped=true&"
import script from "./arrow-btn.vue?vue&type=script&lang=js&"
export * from "./arrow-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88a4926",
  null
  
)

export default component.exports